import { Box } from "@material-ui/core";

const PlanningItemHeader = (props) => {
    return <Box mb={1} display="flex">{props.children}</Box>;
};

export default PlanningItemHeader;